import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import 'semantic-ui-css/semantic.min.css';
import 'semantic-ui-grid/grid.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import Main from './components/Main';


serviceWorker.unregister();
ReactDOM.render(<Main />, document.getElementById('root'));





//import React from 'react';
//import ReactDOM from 'react-dom';
//import './index.css';
//import App from './App';
//import * as serviceWorker from './serviceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
